/**
 * The CategoriesMenu component container selector
 * @type {String}
 */
export const CATEGORIES_MENU_SELECTOR = '.categories-menu-wrapper';
